import { render, staticRenderFns } from "./SettingsPannel.vue?vue&type=template&id=b98267a6&"
import script from "./SettingsPannel.vue?vue&type=script&lang=js&"
export * from "./SettingsPannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports